import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Class Idea Generator™',
  description: 'Ein Express-System zur sofortigen Generierung professioneller Kursideen – beseitigt die Planungslähmung mit einer Kombinationsmatrix für Ziele, Bewegungsmuster und Formate. Nie wieder von Null starten.'
}, {
  title: 'Warm-Up Builder Pack™',
  description: 'Ein schnelles Aufbausystem für intelligente, strukturierte und zielgerichtete Warm-ups, kategorisiert nach Kurstyp und Hauptbewegungsmuster – mit 40 sofort einsetzbaren Aufwärmsequenzen.'
}, {
  title: 'Coaching Cues Cheat Sheet™',
  description: 'Eine Bibliothek exakter Coaching-Cues für die wichtigsten Bewegungsmuster, mit typischen Bewegungsfehlern, passenden Korrekturhinweisen und kurzen Formulierungen für mehr Klarheit und Sicherheit.'
}, {
  title: 'Equipment Switch Guide™',
  description: 'Ein praktischer Anpassungsleitfaden, um jede Einheit schnell anzupassen, wenn Equipment fehlt, der Raum begrenzt ist oder die Gruppengröße sich ändert – mit Austauschmatrizen für jedes Bewegungsmuster.'
}, {
  title: '7-Day Planning Sprint™',
  description: 'Ein strukturiertes Wochenplanungs-System, um die komplette Trainingswoche in einer einzigen 30-minütigen Sitzung zu organisieren – mit Sprint-Sheets, Tagesstrukturen und Kontrollchecklisten.'
}];
export function BonusSection() {
  return <>
      <section className="py-10 px-4 bg-white border-y border-brand-gold/30" data-id="element-14">
        <div className="max-w-4xl mx-auto" data-id="element-15">
          <div className="text-center mb-5" data-id="element-16">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-2" data-id="element-17">
              5 PREMIUM-BONI INKLUSIVE
            </h2>
            <p className="text-base text-brand-graphite/80 max-w-2xl mx-auto" data-id="element-18">
              Sie erhalten außerdem 5 Premium-Boni, die Ihnen helfen, noch mehr
              Zeit zu sparen und Ihren täglichen Coaching-Workflow zu
              verbessern.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6" data-id="element-19">
            {bonuses.map((bonus, i) => <div key={i} className="bg-brand-cream border-2 border-brand-gold/40 p-5 rounded-lg text-center" data-id="element-20">
                <div className="w-12 h-12 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-3" data-id="element-21">
                  <Gift className="w-6 h-6 text-brand-petrol" data-id="element-22" />
                </div>
                <p className="text-xs font-bold text-brand-gold mb-2" data-id="element-23">
                  🎁 BONUS {i + 1} — GRATIS
                </p>
                <h3 className="text-base font-bold text-brand-graphite mb-2" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-sm text-brand-graphite/70 leading-relaxed" data-id="element-25">
                  {bonus.description}
                </p>
              </div>)}
          </div>

          <p className="text-center font-bold text-brand-petrol text-lg" data-id="element-26">
            ALLE 5 BONI SIND HEUTE GRATIS BEI IHREM KAUF
          </p>
        </div>
      </section>

      <section className="py-10 px-4 bg-brand-cream" data-id="element-27">
        <div className="max-w-3xl mx-auto" data-id="element-28">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-graphite mb-5" data-id="element-29">
            WAS SICH VERÄNDERN WIRD
          </h2>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-30">
            {[{
            emoji: '⚡',
            title: 'Stunden pro Woche sparen',
            desc: 'Hören Sie auf, Trainingspläne, Kursstrukturen und Übungsressourcen von Grund auf neu zu erstellen. Öffnen Sie das System, wählen Sie das richtige Framework und starten Sie vollständig vorbereitet.'
          }, {
            emoji: '👑',
            title: 'Größere Coaching-Sicherheit',
            desc: 'Wissen Sie genau, wie Sie jeden Kurs bewerten, strukturieren und dokumentieren – mit der Unterstützung eines professionellen Systems, das Ihre tägliche Entscheidungsfindung optimiert.'
          }, {
            emoji: '🏋️',
            title: 'Bessere Trainingsergebnisse',
            desc: 'Liefern Sie strukturierte, professionell aufgebaute Einheiten, die Engagement, Progressionsklarheit und das Erreichen kurz- und langfristiger Fitnessziele verbessern.'
          }, {
            emoji: '😊',
            title: 'Kundenbindung verbessern',
            desc: 'Halten Sie Ihre Kunden mit professionellen Materialien, klaren Zielen und einer besser organisierten Trainingserfahrung motiviert, die Kompetenz und Engagement zeigt.'
          }].map((item, i) => <div key={i} className="bg-white border-2 border-brand-petrol/20 p-5 rounded-lg" data-id="element-31">
                <div className="text-3xl mb-2" data-id="element-32">{item.emoji}</div>
                <h3 className="text-lg font-bold text-brand-petrol mb-2" data-id="element-33">
                  {item.title}
                </h3>
                <p className="text-brand-graphite/80 text-sm leading-relaxed" data-id="element-34">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}